// @flow
import type { SectionSteps } from 'hooks/sectionsProgress/types';
import PATHS, { SELF_IDENTIFICATION_PATHS } from 'constants/paths';
import {
  isEmergencyContactsRequired,
  isPetsRequired,
  isVehiclesRequired,
} from './utils';
import { VOLUNTARY_SELF_IDENTIFICATION_FIELD_NAMES } from '../AffordaSelfIdentification/AdditionalDetailsVoluntarySelfIdentificationForm/AdditionalDetailsVoluntarySelfIdentification.useFields';
import { ADDITIONAL_DETAILS_FIELD_NAMES } from './AdditionalDetailsForm/AdditionalDetailsForm.useFields';
import { VEHICLE_FIELD_NAMES } from './AdditionalDetailsVehicleForm/AdditionalDetailsVehicleForm.useFields';
import { PETS_FIELD_NAMES } from './AdditionalDetailsPetsForm/AdditionalDetailsPetsForm.useFields';
import { EMERGENCY_CONTACTS_FIELD_NAMES } from './AdditionalDetailsEmergencyContactsForm/AdditionalDetailsEmergencyContactsForm.useFields';

export const SELF_IDENTIFICATION_SECTION_NAMES = {
  ADDITIONAL_DETAILS: 'additionalDetails',
  VEHICLES: 'vehicles',
  PETS: 'pets',
  EMERGENCY_CONTACTS: 'emergencyContacts',
  VOLUNTARY_SELF_IDENTIFICATION: 'voluntarySelfIdentifications',
};

export const SELF_IDENTIFICATION_PATHS_TO_FIELD_NAMES_MAP = {
  [SELF_IDENTIFICATION_PATHS.ADDITIONAL_DETAILS]:
    ADDITIONAL_DETAILS_FIELD_NAMES,
  [SELF_IDENTIFICATION_PATHS.VEHICLES]: VEHICLE_FIELD_NAMES,
  [SELF_IDENTIFICATION_PATHS.PETS]: PETS_FIELD_NAMES,
  [SELF_IDENTIFICATION_PATHS.EMERGENCY_CONTACTS]:
    EMERGENCY_CONTACTS_FIELD_NAMES,
  [SELF_IDENTIFICATION_PATHS.VOLUNTARY_SELF_IDENTIFICATION]:
    VOLUNTARY_SELF_IDENTIFICATION_FIELD_NAMES,
};

export const INITIAL_STEPS = ({
  additionalDetailsFormValues = {},
  isPrimaryProspect,
  isVehiclesValid,
  isPetsValid,
  isEmergencyContactsValid,
}): SectionSteps => {
  const { anyParkedVehicles, anyPetsLiving, anyEmergencyContacts } =
    additionalDetailsFormValues?.choices ?? {};

  return [
    {
      name: SELF_IDENTIFICATION_PATHS.ADDITIONAL_DETAILS,
      path: `${PATHS.SELF_IDENTIFICATION}/${SELF_IDENTIFICATION_PATHS.ADDITIONAL_DETAILS}`,
      required: isPrimaryProspect,
      optional: true,
      complete: false,
      sectionName: SELF_IDENTIFICATION_SECTION_NAMES.ADDITIONAL_DETAILS,
    },
    {
      name: SELF_IDENTIFICATION_PATHS.VEHICLES,
      path: `${PATHS.SELF_IDENTIFICATION}/${SELF_IDENTIFICATION_PATHS.VEHICLES}`,
      required: isVehiclesRequired({ anyParkedVehicles, isVehiclesValid }),
      optional: true,
      complete: false,
      sectionName: SELF_IDENTIFICATION_SECTION_NAMES.VEHICLES,
    },
    {
      name: SELF_IDENTIFICATION_PATHS.PETS,
      path: `${PATHS.SELF_IDENTIFICATION}/${SELF_IDENTIFICATION_PATHS.PETS}`,
      required: isPetsRequired({ anyPetsLiving, isPetsValid }),
      optional: true,
      complete: false,
      sectionName: SELF_IDENTIFICATION_SECTION_NAMES.PETS,
    },
    {
      name: SELF_IDENTIFICATION_PATHS.EMERGENCY_CONTACTS,
      path: `${PATHS.SELF_IDENTIFICATION}/${SELF_IDENTIFICATION_PATHS.EMERGENCY_CONTACTS}`,
      required: isEmergencyContactsRequired({
        anyEmergencyContacts,
        isEmergencyContactsValid,
      }),
      optional: true,
      complete: false,
      sectionName: SELF_IDENTIFICATION_SECTION_NAMES.EMERGENCY_CONTACTS,
    },
    {
      name: SELF_IDENTIFICATION_PATHS.VOLUNTARY_SELF_IDENTIFICATION,
      path: `${PATHS.SELF_IDENTIFICATION}/${SELF_IDENTIFICATION_PATHS.VOLUNTARY_SELF_IDENTIFICATION}`,
      required: true,
      complete: false,
      sectionName:
        SELF_IDENTIFICATION_SECTION_NAMES.VOLUNTARY_SELF_IDENTIFICATION,
    },
  ];
};
